import { defineStore } from "pinia"
import { getChangesDB } from "src/db/databases"
import { STAGNANT_WORK_DAYS } from "src/util/constants/configurations"
import { AttachmentUpload } from "src/util/types/dataModels/attachment"
import { UnsubmittedWork } from "src/util/types/dataModels/unsubmittedWork"

export interface UnsubmittedWorkType {
  unsubmittedWork: UnsubmittedWork
  unsubmittedImages: AttachmentUpload[]
  oldestWorkInDays: number
  hasUnsubmittedWork: boolean
}

export const useUnsubmittedWorkStore = defineStore("pinia-unsubmittedWorkStore", {
  state: (): UnsubmittedWorkType => {
    return {
      unsubmittedWork: <UnsubmittedWork>{},
      unsubmittedImages: [],
      oldestWorkInDays: 0,
      hasUnsubmittedWork: false,
    }
  },

  getters: {
    isWorkStagnant(state: UnsubmittedWorkType): boolean {
      return state.oldestWorkInDays >= STAGNANT_WORK_DAYS
    },
  },

  actions: {
    async updateStagnantWork() {
      const cdb = await getChangesDB()
      this.oldestWorkInDays = await cdb.unsubmitted_work.getOldestWorkDays()
    },

    async updateHasUnsubmittedWork() {
      const cdb = await getChangesDB()
      this.hasUnsubmittedWork = await cdb.unsubmitted_work.hasUnsubmittedWork()
    },
  },
})
